export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_01.d9b21c93.mp4";